import { useState } from "react";
import { CustomModalWindow } from "../modal_window/modalWindow";
import styles from "./Form.module.scss";
import { sendSurveyDataToAirtable } from "../../pages/api/airtable";
import { Loading_ellipsis } from "../loading";

function ApiForm({ closeModal, dictionary }) {
	const [email, setEmail] = useState({ value: "", error: false });
	const [company, setCompany] = useState({ value: "", error: false });
	const [describe, setDescribe] = useState({ value: "", error: false });
	const [formError, setFormError] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [step, setStep] = useState("form"); // form || thank

	const submitForm = async () => {
		setIsLoading(true);
		if (email.value.length < 1 || company.value.length < 1) return setFormError(true);

		const data = {
			email: email.value,
			company: company.value,
			describe: describe.value,
		};

		const rec = await sendSurveyDataToAirtable(data, "tbl19QKZM9ztWATN8");
		setStep("thank");
		setIsLoading(false);
	};

	return (
		<CustomModalWindow closeModal={closeModal}>
			<div className={`${styles.ApiForm} ${isLoading ? styles.loading : ""}`}>
				{step === "form" && (
					<>
						<h2 className={styles.title}>{dictionary["request_a_demo"] || "Request a demo"}</h2>
						{formError && <span className={styles.error}>You must fill in the email and company fields</span>}
						<label className={styles.formItem}>
							<h3>Email</h3>
							<input
								value={email.value}
								onChange={({ target }) => {
									setEmail({ ...email, value: target.value });
									setFormError(false);
								}}
								type="text"
							/>
						</label>
						<label className={styles.formItem}>
							<h3>Company</h3>
							<input
								value={company.value}
								onChange={({ target }) => {
									setCompany({ ...company, value: target.value });
									setFormError(false);
								}}
								type="text"
							/>
						</label>
						<label className={styles.formItem}>
							<h3>Describe your needs</h3>
							<textarea value={describe.value} onChange={({ target }) => setDescribe({ ...describe, value: target.value })} cols="30" rows="10" />
						</label>
						<button disabled={isLoading} onClick={submitForm} className={styles.button}>
							{isLoading ? <Loading_ellipsis /> : dictionary["Submit"] || "Submit"}
						</button>
					</>
				)}
				{step === "thank" && (
					<>
						<h2 className={styles.title}>{dictionary["thank_you"] || "Thank you!"}</h2>
						<p>{dictionary["your_request_was_submitted"] || "Your request was submitted."}</p>
						<button onClick={closeModal} className={styles.button}>
							{dictionary["Great!!"] || "Great!"}
						</button>
					</>
				)}
			</div>
		</CustomModalWindow>
	);
}

export default ApiForm;
